import './LoginForm.css';

// import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';
import { DataValidator } from 'components/validation/data/DataValidator';
import * as React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from 'stores/ducks/User.duck';
import * as yup from 'yup';

import { Label } from 'reactstrap';

interface ILoginFormState {
  password: {
    username: string;
    password: string;
  };
  facebook: {
    name?: string | null;
    accessToken?: string | null;
    clicked: boolean;
  };
  isValid: boolean;
  error: boolean;
  changePassword: boolean;
  success: boolean;
}

interface IProps {
  isLoggedIn?: boolean;
  isLoading?: boolean;
  dispatch?: any;
  cookies?: any;
  onForget?: any;
}

class ForgotPasswordForm extends React.Component<IProps, ILoginFormState> {
  public state: ILoginFormState = {
    password: {
      username: "",
      password: ""
    },
    facebook: {
      name: null,
      accessToken: null,
      clicked: false
    },
    isValid: true,
    error: false,
    changePassword: false,
    success: false
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
  }

  public componentWillUnmount() {
    this.setLoading(false);
  }

  public forgotPassword() {
    this.setState({ changePassword: true })
  }

  public handleChangeInput(e: any) {
    const { state } = this;
    const { password } = this.state;
    this.setState({
      ...state,
      password: {
        ...password,
        [e.target.name]: e.target.value
      },
      error: false,
      success: false
    });
  }

  public handleSuccess() {
    return true;
  }

  public handleError() {
    return false;
  }

  public handleSubmit(e: any) {
    e.preventDefault();
    const { username } = this.state.password;

    fetchGraphQL(
      `
      mutation { 
        user {
          requestNewPassword(email:"${username}")
        }
      }
      `
    ).then(res => {
      if (res.user.requestNewPassword) {
        this.setState({ error: false, success: true })
      } else {
        this.setState({ error: true, success: false })
        alert('Sorry, We were unable to find your email in our system.')
      }
    })
  }

  public render() {
    if (this.props.isLoggedIn) {
      return <Redirect to="/dashboard/overview" />;
    }

    if (this.state.changePassword) {
      return <Redirect to="/login" />;
    }

    // const error = this.state.error === true
    //   ?
    //   <div>
    //     <br />
    //     <Error content={"Sorry, We were unable to find your email in our system."} />
    //   </div>
    //   : null

    const success = this.state.success === true
      ?
      <div>
        <br />
        <Success content={"Please follow the link we sent to you to reset password"} />
      </div>
      : null

    return (
      <React.Fragment>
        <div>
          <React.Fragment>
            <DataValidator
              rules={{
                email: yup
                  .string()
                  .required()
                  .email()
              }}
              data={{
                email: this.state.password.username
              }}
              isValid={valid => this.setState({ isValid: valid })}
            >
              <div>
                <form
                  onSubmit={this.handleSubmit}
                >
                  {this.props.isLoading ? (
                    <div className="p-3 w-100 text-center">
                      <ClipLoader color={"#000000"} loading={true} />
                    </div>
                  ) : (
                      <React.Fragment>
                        <p>
                          <br />
                        </p>
                        <Label>
                          Email
                      </Label>
                        <input
                          type="email"
                          name="username"
                          value={this.state.password.username}
                          onChange={this.handleChangeInput}
                          style={{ width: '100%' }}
                          required={true}
                        />
                        <div className="login-button-div">
                          <br />
                          <button
                            role="submit"
                            type="submit"
                            className="new-button-blue-outline"
                          >
                            RESET
                    </button>
                          <p />
                          <button className="button_link" onClick={() => { window.location.pathname = '/login' }}>Back to login</button>
                          <p />
                          {/* {error} */}
                          {success}
                        </div>
                        <div className={"pl-3 pr-3"}>
                          <div className="login-button-div" />
                        </div>
                      </React.Fragment>
                    )}
                </form>
              </div>
            </DataValidator>
          </React.Fragment>
        </div>
      </React.Fragment>
    );
  }

  private setLoading(e: any | boolean) {
    this.props.dispatch(
      UserDucks.setLoading(e === true || e === false ? e : true)
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: UserDucks.isLoading(state),
    isLoggedIn: UserDucks.isAuthenticated(state)
  };
};

export default withCookies(connect(mapStateToProps)(ForgotPasswordForm));



// WEBPACK FOOTER //
// ./src/pages/auth/login/components/login-form/ForgotPassword.tsx